import { render } from "./T.vue?vue&type=template&id=60b39804"
import script from "./T.vue?vue&type=script&lang=js"
export * from "./T.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__